export default __webpack_public_path__ + "static/media/insta.2754fe98.svg";